import { t } from '@hefe/i18n';
import { Inventory, RequestBasePostInventoryTransfer } from '@hefe/models';
import { InventoryApi } from '@hefe/store';
import { formatDatabaseDate } from '@hefe/utils';
import { Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';
import CustomForm from '../../../core/components/form/custom-form';

interface CreateInventoryAdminReturnRequestFormProps {
  inventory: Inventory;
  open?: boolean;
  setOpen: (open: boolean) => void;
}

export default function CreateInventoryAdminReturnRequestForm(
  props: CreateInventoryAdminReturnRequestFormProps
) {
  const { inventory } = props;

  const [open, setOpen] = useState(props.open);
  const [saving, setSaving] = useState(false);

  const [createAdminReturn] =
    InventoryApi.useCreateAdminReturnRequestMutation();

  useEffect(() => {
    setOpen(props.open ?? false);
  }, [props.open]);

  useEffect(() => {
    props.setOpen(open ?? false);
  }, [open]);

  const onSubmit = (values: any, resetForm: any) => {
    const dueDate = values.due_date
      ? formatDatabaseDate(values.due_date)
      : undefined;
    const request: RequestBasePostInventoryTransfer = {
      inventory_id: inventory.id,
      to_user_id: values.user_id,
      comment: values.comment,
      ...(dueDate && { due_date: dueDate }),
    };

    setSaving(true);
    createAdminReturn(request)
      .unwrap()
      .then(() => {
        setOpen(false);
        resetForm();
      })
      .catch(() => null)
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Modal
      open={open}
      footer={null}
      closable
      zIndex={1000}
      bodyProps={{
        style: { paddingTop: 50 },
      }}
      title={t('inventory.transfers.return.admin_request.title')}
      onCancel={() => setOpen(false)}
    >
      <Typography.Paragraph>
        {t('inventory.transfers.return.admin_request.description')}
      </Typography.Paragraph>
      <CustomForm
        key={`create-inventory-transfer-admin-return-request-form`}
        fields={[
          {
            name: 'comment',
            label: t('inventory.transfers.attributes.comment'),
            type: 'text',
            rules: [],
          },
          {
            name: 'due_date',
            label: t('inventory.transfers.attributes.due_date'),
            type: 'date',
            rules: [],
          },
        ]}
        loading={saving}
        onSubmit={onSubmit}
      />
    </Modal>
  );
}
